import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { ThreeDots } from "react-loader-spinner";
import useTranslation from "hooks/useTranslation";
import { RingingIconComponent } from "assets/icons";
import Alert from "../Alert";
import styles from "../styles.module.scss";
import { checkNotificationPermission } from "utils/browserNotifs";
import { handleNotificationPermission } from "../../../firebase";
import { getBrowserNotifPermissionState } from "utils/browserNotifs";
import { setShowPopupNotifDisplay } from "redux/general-data/general-data.actions";

const { getNotifMsg } = require("utils/message");

const NOTIF_ALERT_KEY_NAME_IN_LOCAL_STORAGE = "DO_NOT_SHOW_NOTIF_ALERT_AGAIN";

function ActivateBrowserNotifAlert({
  isActiveBrowserNotification,
  setIsActiveBrowserNotification,
  //   wrire types jsDoc
}) {
  const { getAppLocale, getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const [isLoadingNotifActive, setIsLoadingNotifActive] = useState(false);
  const locale = getAppLocale();
  const { t } = getTranslation();
  const showedNotifAlertOnceBefore =
    localStorage.getItem(NOTIF_ALERT_KEY_NAME_IN_LOCAL_STORAGE) === "true";
  const notifState = getBrowserNotifPermissionState();
  const renderActiveNotifBtn = notifState && notifState !== "denied";
  const dispatch = useDispatch();

  const showAlert =
    !isActiveBrowserNotification &&
    !window.isOnWebView &&
    !showedNotifAlertOnceBefore;

  /**
   sets notif display in the localstorage when user hits close button. 
    It is neccessary to avoid over display of this notif.
    This storage will get reset when user logs out.
   */
  const setNotifDisplayInLocalStorage = () => {
    localStorage.setItem(NOTIF_ALERT_KEY_NAME_IN_LOCAL_STORAGE, true);
  };

  const handleClickBrowserNotifActiveBtn = async () => {
    if (isLoadingNotifActive) return;

    const result = await handleNotificationPermission(
      true,
      locale,
      setIsLoadingNotifActive
    );

    if (result === "success") {
      setIsActiveBrowserNotification(true);
      dispatch(setShowPopupNotifDisplay(true));
    }
  };

  const getNotifBarText = () => {
    if (!notifState) {
      return getNotifMsg("NOTIF_NOT_SUPPORTED", locale);
    }

    const isActivePossible = notifState !== "denied";

    if (!isActivePossible) {
      return getNotifMsg("NOTIF_ENABLE_ACCESS_BLOCKED", locale);
    }

    return getNotifMsg("ALLOW_NOTIFICATION", locale);
  };

  const renderThreeDotsLoader = (
    <ThreeDots
      height="20"
      width="30"
      radius="9"
      color="#841474"
      ariaLabel="three-dots-loading"
      wrapperStyle={{ justifyContent: "center" }}
      visible={true}
      wrapperClass={styles.loading_notif_active}
    />
  );

  const renderActionBtn = renderActiveNotifBtn && (
    <button
      className={styles.action_btn}
      onClick={handleClickBrowserNotifActiveBtn}
      data-loading={isLoadingNotifActive}
    >
      {isLoadingNotifActive ? renderThreeDotsLoader : t("ACTIVATE")}
    </button>
  );

  useEffect(() => {
    checkNotificationPermission(setIsActiveBrowserNotification);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    showAlert && (
      <Alert
        icon={<RingingIconComponent />}
        text={getNotifBarText()}
        actionBtn={renderActionBtn}
        type="notif"
        onCloseNotif={setNotifDisplayInLocalStorage}
      />
    )
  );
}

export default ActivateBrowserNotifAlert;
